import vuei18n from '@/plugins/vue-i18n';
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const LOWER_CASE_REGEX = /[a-z]/;
const UPPER_CASE_REGEX = /[A-Z]/;
const NUMBER_REGEX = /[0-9]/;
const CURRENCY_REGEX = /[,.0-9]/;
const PHONE_NUMBER_REGEX = /^\d+$/;
const NIT_COLOMBIA_REGEX = /^(\d{3}\.?\d{3}\.?\d{3}-\d{1})$/; 
const NIT_BRASIL_REGEX = /^(\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-\d{2})$/;


const inputRules = {
  nitColombia: (value) => {
    return NIT_COLOMBIA_REGEX.test(value) 
      ? true 
      : vuei18n.t('errors.inputValidations.invalidNIT', { fieldName: vuei18n.t('rcmAgreements.basicInformation.taxIdentificationNumber') });
  },
  nitBrasil: (value) => {
    return NIT_BRASIL_REGEX.test(value) 
      ? true 
      : vuei18n.t('errors.inputValidations.invalidNIT', { fieldName: vuei18n.t('rcmAgreements.basicInformation.taxIdentificationNumber') });
  },
  required: value => !!value || vuei18n.t('errors.inputValidations.required'),
  passwordConfirmation: (x, y) => x === y || vuei18n.t('changePassword.badConfirmPassword'),
  email: value => EMAIL_REGEX.test(value) || vuei18n.t('errors.inputValidations.invalidFormat'),
  maxLength: maxLength => value => {
      if (!value) {
          return true;
      }
      return value.length <= maxLength || vuei18n.tc('errors.inputValidations.maxLength', [maxLength])
  },
  min:  minLength=> value =>
    (value && value.length >= minLength) || vuei18n.tc('updatePassword.passwordMinLength', [minLength]),
  specialCharacter: characters => value => (value && hasSpecialChars(value, characters)) || vuei18n.tc('updatePassword.specialCharacter', [characters]),
  lowerCase: value =>
    (value && LOWER_CASE_REGEX.test(value)) || vuei18n.t('updatePassword.passwordLowerCase'),
  upperCase: value =>
    (value && UPPER_CASE_REGEX.test(value)) || vuei18n.t('updatePassword.passwordUpperCase'),
  number: value =>
    (value && CURRENCY_REGEX.test(value)) || vuei18n.t('updatePassword.number'),
  currency: value =>
    (value && NUMBER_REGEX.test(value)) || vuei18n.t('errors.inputValidations.currency'),
  diagnosisRepeated: (value, diagnosisType) => {
    const message = diagnosisType === 'MEDICAL_DIAGNOSIS' ? 'diagnoses.errors.repeated' : 'patients.allergies.errors.repeated';

    return !value || vuei18n.t(message)
  },
  phoneNumber: value => {
    if (value.length < 6) {
      return vuei18n.t('beneficiaryResults.phone.minLength');
    }
    if(!PHONE_NUMBER_REGEX.test(value)){
      return vuei18n.t('beneficiaryResults.phone.validation')
    }
  },
  validDynamicField: value => {
    if (!value) {
      return true;
    }

    const openingBrackets = value.match(/\${/g) || []
    const closingBrackets = value.match(/}/g) || []

    if(!openingBrackets || !closingBrackets){
      return true;
    }

    return openingBrackets.length === closingBrackets.length || vuei18n.t('errors.inputValidations.dynamicFieldInvalidFormat')
  }
}


function hasSpecialChars(str, characters) {
  const specialCharsSet = new Set(characters);
  for (let letter of str) {
    if (specialCharsSet.has(letter)) {
      return true;
    }
  }
  return false;
}

function inputRulesFromSponsorForm(fieldProperties){
  let rules = []
  if(fieldProperties.required){
      let requiredFunction = (v) => !!v || vuei18n.t('errors.inputValidations.required')
      rules.push(requiredFunction);

      if(fieldProperties.pattern){
        let pattern = new RegExp(fieldProperties.pattern);
        let patternFunction = (v) => v && pattern.test(v) || vuei18n.t('errors.inputValidations.invalidFormat')
        rules.push(patternFunction)
      }

      if(fieldProperties.maxLength){
        let maxLengthFunction = (v) => !!v && v.length <= fieldProperties.maxLength || vuei18n.tc('errors.inputValidations.maxLength', [fieldProperties.maxLength])
        rules.push(maxLengthFunction)
      }

      if(fieldProperties.minLength){
        let minLengthFunction = (v) => !!v && v.length >= fieldProperties.minLength || vuei18n.tc('errors.inputValidations.minLength', [fieldProperties.minLength])
        rules.push(minLengthFunction)
      }
  }
  return rules;
}

export { inputRules, inputRulesFromSponsorForm }
